import { Box } from "@chakra-ui/react";
import PlayingCard from "./PlayingCard";

export default function GarrettsCards({ gameState, stepPhase }) {
  const { garrettDownCards, garrettCardVisiblity } = gameState;

  let showFouthCardTop = false;

  if (
    stepPhase === "resolve" ||
    stepPhase === "war_flip_k" ||
    stepPhase === "war_flip_g" ||
    stepPhase === "war_reveal" ||
    stepPhase === "war_reveal_all"
  ) {
    showFouthCardTop = true;
  }

  // handle case where garrett only has one card
  if (garrettDownCards.length === 1) {
    return (
      <Box transform="rotate(10deg)">
        <PlayingCard
          rank={garrettDownCards[0].rank}
          suit={garrettDownCards[0].suit}
          isVisible={garrettCardVisiblity[0]}
        />
      </Box>
    );
  } else if (garrettDownCards.length > 1) {
    return (
      <Box position="relative">
        <Box transform="rotate(10deg) translateY(-30px)">
          <PlayingCard
            rank={garrettDownCards[0].rank}
            suit={garrettDownCards[0].suit}
            isVisible={garrettCardVisiblity[0]}
          />
        </Box>

        {/* fourth down card (to flip) */}
        {garrettDownCards[4] && (
          <Box
            position="absolute"
            top="10px"
            left="-40px"
            zIndex={showFouthCardTop ? "5" : "0"}
          >
            <PlayingCard
              rank={garrettDownCards[4].rank}
              suit={garrettDownCards[4].suit}
              isVisible={garrettCardVisiblity[4]}
            />
          </Box>
        )}
        {/* third down card */}
        {garrettDownCards[3] && (
          <Box position="absolute" top="20px" left="0px">
            <PlayingCard
              rank={garrettDownCards[3].rank}
              suit={garrettDownCards[3].suit}
              isVisible={garrettCardVisiblity[3]}
            />
          </Box>
        )}
        {/* second down card */}
        {garrettDownCards[2] && (
          <Box position="absolute" top="30px" left="40px">
            <PlayingCard
              rank={garrettDownCards[2].rank}
              suit={garrettDownCards[2].suit}
              isVisible={garrettCardVisiblity[2]}
            />
          </Box>
        )}
        {/* first down card */}
        {garrettDownCards[1] && (
          <Box position="absolute" top="40px" left="80px">
            <PlayingCard
              rank={garrettDownCards[1].rank}
              suit={garrettDownCards[1].suit}
              isVisible={garrettCardVisiblity[1]}
            />
          </Box>
        )}
      </Box>
    );
  }
}
